import React from "react";
import App from "./App";

/**
 * Wrapper to handle v2 layout with a global ActionBar and Map (see: TC-787)
 */
const AppV2 = props => <App layoutV2 {...props} />;

export default AppV2;
